import { useInfiniteQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import AddressmanagerService from "app/data/address-manager/addressService";

export const useAddressList = (terminal: string,
    search: string,
    city: string,
    state: string,
    zip: string,
    flag: string) => {
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        refetch,
        isRefetching
    } = useInfiniteQuery({
        queryKey: [QUERY_KEYS.ADDRESS_LIST, search, terminal, city, state, zip, flag],
        queryFn: async ({ pageParam = 0 }) => {
            return await AddressmanagerService.getInstance().getListAddressesNearTerminal(
                terminal,
                search,
                city,
                state,
                zip,
                pageParam,
                flag
            );
        },
        getNextPageParam: (lastPage) => {
            if (lastPage.last) return undefined;
            return lastPage.pageable.pageNumber + 1;
        },
        keepPreviousData: false,
        refetchOnWindowFocus: false,
        retry: false,
    });

    return {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        refetch,
        isRefetching
    };
}